module.exports = __webpack_public_path__ + "static/media/userProfile.74878fb4.pdf";